import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../../utils";
/**
 * StatCard - A reusable statistics card component
 *
 * Displays a metric with an icon, title, value, and description.
 * Used for dashboards and detail pages to show aggregated statistics.
 */ function StatCard({ icon, title, value, description, iconClassName, className, children, ...props }) {
    const displayValue = value === null || value === undefined ? "-" : value;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("relative rounded-lg border bg-card p-5 shadow-xs", className),
        ...props,
        children: [
            icon && /*#__PURE__*/ _jsx("div", {
                className: cn("absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-md", iconClassName ?? "bg-info-surface"),
                children: icon
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: cn(icon && "pr-14"),
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-sm font-medium uppercase text-muted-foreground",
                        children: title
                    }),
                    children ? /*#__PURE__*/ _jsxs("div", {
                        className: "mt-1 flex items-baseline gap-2",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-3xl font-bold tracking-tight",
                                children: displayValue
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-sm text-muted-foreground",
                                children: description
                            })
                        ]
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "mt-1 text-3xl font-bold tracking-tight",
                                children: displayValue
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "mt-1 text-sm text-muted-foreground",
                                children: description
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
}
export { StatCard };

//# sourceMappingURL=stat-card.js.map